import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, BODY } from "../shared";

export default function SoundsCrazySection() {
  return (
    <Section testId="soundscrazy-section" className="py-24 md:py-36">
      <SectionLabel testId="soundscrazy-label">Sounds crazy?</SectionLabel>
      <div className="max-w-3xl space-y-6">
        <Reveal>
          <p className={BODY}>
            Wenn Du erwartest, dass das einfach von selbst passiert, dann ist es das.
          </p>
        </Reveal>
        <Reveal delay={0.04}>
          <p className={BODY}>
            Nicht, weil es falsch ist – sondern weil wir in einer anderen Welt groß geworden sind, Arbeit anders kennengelernt haben.
          </p>
        </Reveal>
        <Reveal delay={0.06}>
          <p className={BODY}>
            Jetzt haben wir diese alte Arbeitswelt und merken seit Jahren, dass diese nicht mehr passt. Ein Teil der Menschen ist resigniert. Ein anderer Teil sucht aktiv nach Lösungen.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-heading text-xl font-600 uppercase tracking-tight text-cognac-2 md:text-2xl" style={{ fontWeight: 600 }}>
            Wenn Du das hier liest, gehörst Du zum zweiten Teil.
          </p>
        </Reveal>
        <Reveal delay={0.14}>
          <p className={BODY}>
            Den anderen Weg gibt es. Dafür müssen wir aber komplett das Spielfeld verlassen, von dem wir bisher glaubten, zu wissen, was Arbeit ist und wie Arbeit funktioniert.
          </p>
        </Reveal>
      </div>
    </Section>
  );
}
